import { render, staticRenderFns } from "./icon-list.vue?vue&type=template&id=a56976b8&"
import script from "./icon-list.vue?vue&type=script&lang=ts&"
export * from "./icon-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports